
import Pagination from "../shop/PaginationDefault.vue";
import { useStore } from "vuex";
import { computed, watch, Ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { wrapLoading } from "../../../utils/wrap_loading";
import { removeQueries, updateQuery } from "../../../utils/routing_utils";
import { getOrderFromURL } from "../../../utils/order_utils";
import { dispatchError } from "../../../utils/error_handling";

export default {
  name: "CommentsModal",
  components: { Pagination },
  props: {
    title: { type: String, required: true }
  },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter()
    const route = useRoute();

    const commentsPage: Ref<number> = computed(
      () => store.getters["course_module/commentsPage"]
    );

    const closeCommentsModal = async () => {
      await removeQueries(router, ["pageDefault", "courseID"]);
      emit("closeCommentsModal");
    };

    const updateCommentsPage = async (newPage: number) => {
      await updateQuery(router, "pageDefault", newPage.toString());
      await loadContentCommentsByPage(newPage);
    };

    const loadContentCommentsByPage = async (page: number) => {
      const order = getOrderFromURL(route);
      try {
        await wrapLoading(async () => {
          await store.dispatch("course_module/loadContentCommentsById", {
            courseID: Number(route.query.courseID),
            order: order
          });
        });
      } catch (e) {
        console.error(e);
        await dispatchError(e);
      }
    };

    watch(
      () => route.query.pageDefault,
      async newPage => {
        if (newPage) {
          await loadContentCommentsByPage(Number(newPage));
        }
      },
      { immediate: true }
    );

    return {
      commentsPage,
      closeCommentsModal,
      updateCommentsPage,
      updateQuery
    };
  }
};
